
interface HeroSectionProps {
  title: string;
  description: string;
  backgroundImage: string;
}

export function HeroSection({ title, description, backgroundImage }: HeroSectionProps) {
  return (
    <section 
      className="relative pb-4 overflow-hidden"
      style={{
        backgroundImage: `url('${backgroundImage}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container max-w-5xl relative z-10">
        <div className="mb-4">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2 text-[#1E3A8A]">{title}</h1>
          <p className="text-sm md:text-[15px] text-[#1E3A8A]/90 max-w-2xl">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}
